/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React, {Component} from 'react';
import {Button, Card, Col, Form, Input, Row, Spin, Table,} from "antd";
import {connect} from "react-redux";
import {searchResource} from "../../appRedux/actions/JobCard";
import {fetchFilter} from "../../appRedux/actions";
import AccessControl from "../../components/AccessControl";

const {Search} = Input;

class JobCardSearch extends Component {

  componentDidMount() {
    this.columns = [
      {
        title: 'Job Card No',
        dataIndex: 'jobCardNo',
        key: 'jobCardNo',
        render: (value, record) => {
          return record && record.jobCardNo ? (
              <Button key={value} className='button-for-job-card'
                      onClick={this.linkHandler.bind(this, record, 'jobcard', 'Open')}>{'' + (record && record.jobCardNo)}</Button>) :
            <div>NA</div>
        },
      },
      {
        title: 'Complaint',
        dataIndex: 'complaintNo',
        key: 'complaintNo',
      },
      {
        title: 'Asset',
        dataIndex: 'assetCode',
        key: 'assetCode',
      },
      {
        title: 'Asset Type',
        dataIndex: 'assetType',
        key: 'assetType',
      },
      {
        title: 'Asset Sub Type',
        dataIndex: 'equipmentSubType',
        key: 'equipmentSubType',
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
      },
      {
        title: 'Sub Location',
        dataIndex: 'client',
        key: 'client',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
    ];
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if(nextProps && nextProps.searchData && JSON.stringify(this.props.searchData) !== JSON.stringify(nextProps.searchData)) {
  //     console.log(nextProps.searchData);
  //   }
  // }

  linkHandler = (record, page, route) => {
    this.props.history.push(`/job-card/report/${record._id}`);
  };

  render() {
    const {loading, searchData} = this.props;
    return (
      <div>
        <Spin spinning={loading}>
          <Card className={`gx-card-metrics`}>

            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
                               roles={this.props.authUser ? this.props.authUser.roles : []} render={(_) => {
                  return <Search
                    placeholder="Enter Job Card No"
                    enterButton='Search'
                    size="large"
                    style={{width: 350}}
                    onSearch={value => this.props.searchResource(value)}
                  />
                }}/>
              </Col>
            </Row>
            {
              searchData && searchData.length > 0 &&
              <Table
                bordered
                pagination={'none'}
                loading={loading}
                columns={this.columns}
                dataSource={searchData}
              />
            }
          </Card>
        </Spin>
      </div>
    )
      ;
  }
}

const mapStateToProps = ({auth, jobCard, commonData}) => {
  return {
    authUser: auth.authUser,
    searchData: jobCard.searchData,
    resource: jobCard.resource,
    loading: commonData.loading,
    filters: commonData.filters,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchFilter,
    searchResource
  };
}

const JobCardList = Form.create({name: 'job-card-search'})(JobCardSearch);
export default connect(mapStateToProps, mapDispatchToProps())(JobCardList);
